const ACCESS_TOKEN_KEY = 'ce_access_token';
const USER_KEY = 'ce_user';

export interface AuthUser {
  id: string;
  email: string;
  role: 'admin' | 'moderator';
  createdAt: string;
}

type Listener = () => void;
const listeners = new Set<Listener>();

let cachedUserRaw: string | null = null;
let cachedUser: AuthUser | null = null;

function readUserFromStorage(): AuthUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (raw === cachedUserRaw) return cachedUser;
  cachedUserRaw = raw;
  if (!raw) {
    cachedUser = null;
    return null;
  }
  try {
    cachedUser = JSON.parse(raw) as AuthUser;
  } catch {
    cachedUser = null;
  }
  return cachedUser;
}

readUserFromStorage();

function notify(): void {
  for (const listener of listeners) listener();
}

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  notify();
}

export function getUser(): AuthUser | null {
  return cachedUser;
}

export function setUser(user: AuthUser): void {
  const serialized = JSON.stringify(user);
  localStorage.setItem(USER_KEY, serialized);
  cachedUserRaw = serialized;
  cachedUser = user;
  notify();
}

export function clearAuth(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  cachedUserRaw = null;
  cachedUser = null;
  notify();
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
